// reusable aliases for mutations
export const ADMIN_MUTATIONS = {
  SET_ADMIN: 'SET_ADMIN',
  REMOVE_ADMIN: 'REMOVE_ADMIN',
};

export const state = () => ({
  signed: 0,
});

export const mutations = {
  [ADMIN_MUTATIONS.SET_ADMIN](state, signed) {
    state.signed = signed;
  },

  [ADMIN_MUTATIONS.REMOVE_ADMIN](state) {
    state.signed = 0;
  },
};

export const actions = {
  async setAdmin({ commit }, { signed }) {
    commit(ADMIN_MUTATIONS.SET_ADMIN, signed);
    sessionStorage.setItem('auth_is_admin', signed);
  },

  removeAdmin({ commit }) {
    commit(ADMIN_MUTATIONS.REMOVE_ADMIN);
    sessionStorage.removeItem('auth_is_admin', 0);
  },
};

export const getters = {
  isSigned: (state) => {
    return process.client
      ? sessionStorage.getItem('auth_is_admin')
      : state.signed;
  },
};
